var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.7589 16.5904C18.0802 16.9116 18.0813 17.4314 17.7564 17.7564C17.4337 18.079 16.9122 18.0807 16.5904 17.7589L12.1045 13.2731C11.0619 14.0697 9.75904 14.5428 8.34563 14.5428C4.92302 14.5428 2.14844 11.7682 2.14844 8.34563C2.14844 4.92302 4.92302 2.14844 8.34563 2.14844C11.7682 2.14844 14.5428 4.92302 14.5428 8.34563C14.5428 9.75904 14.0697 11.0619 13.2731 12.1045L17.7589 16.5904ZM8.34567 12.8902C10.8556 12.8902 12.8903 10.8555 12.8903 8.34556C12.8903 5.83564 10.8556 3.80095 8.34567 3.80095C5.83575 3.80095 3.80106 5.83564 3.80106 8.34556C3.80106 10.8555 5.83575 12.8902 8.34567 12.8902Z","fill":"#6F7881"}));
}

Search.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Search;

Search.default = Search;
